import React, {Fragment} from 'react';

class AppFooter extends React.Component {
    render() {


        return (
            <Fragment>
                <div className="app-footer">
                    <div className="app-footer__inner">
                        <div className="app-footer-left">
                        </div>
                        <div className="app-footer-right">
                            <p class="mt-3 text-muted">© {new Date().getFullYear()} LMC Fund</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        )}
}

export default AppFooter;